import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import { useAuth, orgTypeHomePath, orgTypeToFrontendRole } from "@/lib/auth";
import { ROLE_META } from "@/data/sidebars";
import { Toaster } from "@/components/ui/sonner";
import { Sheet, SheetContent } from "@/components/ui/sheet";

const SIDEBAR_WIDTH = "16rem";

export default function DashboardLayout({ role }) {
  const { user } = useAuth();
  const [mobileSidebarOpen, setMobileSidebarOpen] = React.useState(false);
  if (!user) return <Navigate to="/login" replace />;

  // Determine the user's frontend role from their org_type
  const userFrontendRole = user.frontendRole || orgTypeToFrontendRole(user.org_type);

  // If the user's org_type doesn't map to this layout's role, redirect them
  if (userFrontendRole !== role) {
    return <Navigate to={orgTypeHomePath(user.org_type)} replace />;
  }

  const meta = ROLE_META[role];
  return (
    <div className={`${meta.className} min-h-screen bg-stone-100 md:pl-64`}>
      <Sidebar role={role} />
      <Sheet open={mobileSidebarOpen} onOpenChange={setMobileSidebarOpen}>
        <SheetContent side="left" className="w-[16rem] p-0">
          <Sidebar role={role} mobile onNavigate={() => setMobileSidebarOpen(false)} />
        </SheetContent>
      </Sheet>
      <div className="flex min-w-0 flex-1 flex-col md:min-h-screen">
        <TopBar role={role} onMenuClick={() => setMobileSidebarOpen(true)} />
        <main className="flex-1 min-w-0 overflow-x-hidden overflow-y-auto px-5 py-6 md:px-8 md:py-8 animate-page-enter">
          <Outlet />
        </main>
      </div>
      <Toaster richColors position="top-right" />
    </div>
  );
}
